var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LLSpoilerTogglerCircleArrow",class:_vm.classList},[_c('CircleArrowUpIcon',{staticClass:"LLSpoilerTogglerCircleArrow__icon",class:{ LLSpoilerTogglerCircleArrow__icon_expanded: _vm.expanded }}),_c('div',{staticClass:"LLSpoilerTogglerCircleArrow__title"},[_vm._t("title")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }